import { useState } from 'react';
import { Search } from 'lucide-react';
import { Select, SelectTrigger, SelectContent, SelectItem, SelectValue } from '@/components/ui/select';

interface Option {
  value: string;
  label: string;
}

interface Props {
  value: string;
  onValueChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  triggerClassName?: string;
}

/** A Select with a search box above the option list — matches the Figma "assign salesperson/handler" dropdown. */
export function SearchableSelect({ value, onValueChange, options, placeholder = 'Select', triggerClassName }: Props) {
  const [query, setQuery] = useState('');
  const filtered = options.filter((o) => o.label.toLowerCase().includes(query.toLowerCase()));

  return (
    <Select value={value} onValueChange={onValueChange} onOpenChange={(open) => !open && setQuery('')}>
      <SelectTrigger className={triggerClassName}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        <div className="flex items-center gap-2 border-b border-smoke px-3 py-2">
          <Search size={13} className="shrink-0 text-lightGray" />
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => e.stopPropagation()}
            placeholder="Search"
            className="w-full border-0 bg-transparent text-sm text-black placeholder:text-lightGray outline-none"
          />
        </div>
        {filtered.length === 0 ? (
          <p className="px-3 py-3 text-sm text-lightGray">No results</p>
        ) : (
          filtered.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))
        )}
      </SelectContent>
    </Select>
  );
}
